import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { GameClient } from './net/client.js';
import './styles.css';

const client = new GameClient();
client.connect();

// Phones suspend sockets within seconds of locking, so probe and resync the
// moment the tab is looked at again rather than waiting for a timeout.
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') client.wake();
});
window.addEventListener('online', () => client.wake());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App client={client} />
  </StrictMode>,
);
